import { useEffect } from 'react';
import PromptsPageContainer from '../../components/openai/prompts';



const Prompts = () => {

  return <PromptsPageContainer />;
};
export default Prompts;
